import { useEffect, useState, type MutableRefObject } from "react";
import type { PairingClient, TodoItem } from "../protocol";

/** The selected session's live to-do checklist. Resubscribes when the selection changes. */
export function useSessionTodos(
  clients: MutableRefObject<Map<string, PairingClient>>,
  selected: string | null,
  /** From useSessions — re-runs the subscription once the client for this selection exists (see useSessions). */
  clientsVersion: number,
): TodoItem[] {
  const [todos, setTodos] = useState<TodoItem[]>([]);
  useEffect(() => {
    setTodos([]);
    if (!selected) return;
    const [pid, sid] = selected.split("/");
    const unsub = clients.current.get(pid)?.subscribeTodos(sid, setTodos);
    return () => unsub?.();
  }, [selected, clientsVersion]);
  return todos;
}
